import Gtm from '@grebban/gtm';
import type { FormFlow } from '@activebrands/core-web/libs/Events/types';

export default ({ flow }: { flow?: FormFlow }) => {
    Gtm.addDataLayerEvent('form_submit', {
        form_id: flow,
    });
};
